import {RequestBasis} from "./RequestBasis";

export class InstrumentErrorsRequest extends RequestBasis {
  myTaskHash: string;
  projectInstrumentId: number;
  errorCode: string;
}
